/**
 * 格式化时间为 mm:ss 格式
 * @param {number} seconds - 秒数
 * @returns {string} 格式化的时间字符串，例如 "03:45"
 */
export const formatTime = seconds => {
  if (isNaN(seconds)) return "00:00";
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
};
// 时间转换工具
export const timeUtils = {
  // 秒转 分:秒 格式 (02:06)
  secondsToTime(seconds) {
    if (!seconds && seconds !== 0) return "00:00";
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  },

  // 秒转剩余时间文本 (剩余3分钟 / 剩余1小时20分钟)
  // 如果 seconds = 0 → 返回 null，让上层逻辑去展示总时长
  secondsToRemainingText(seconds) {
    if (!seconds && seconds !== 0) return null;
    if (seconds === 0) return null; // ⭐ 关键：不显示剩余0分钟

    const mins = Math.ceil(seconds / 60); // 向上取整
    if (mins < 60) {
      return `剩余${mins}分钟`;
    } else {
      const hours = Math.floor(mins / 60);
      const remainingMins = mins % 60;
      return remainingMins > 0
        ? `剩余${hours}小时${remainingMins}分钟`
        : `剩余${hours}小时`;
    }
  },

  // 计算剩余时长
  getRemainingTime(duration, progress) {
    const remaining = Number(duration) - Number(progress);
    return Math.max(0, remaining);
  },

  // 根据场景选择显示内容
  getDisplayTime(duration, progress, useRemainingText = true) {
    const remaining = this.getRemainingTime(duration, progress);

    // ⭐ 如果剩余为 0 → 展示总时长 02:06
    if (remaining === 0) {
      return this.secondsToTime(duration);
    }

    if (useRemainingText && progress > 0) {
      const txt = this.secondsToRemainingText(remaining);
      if (txt) return txt;
    }

    return this.secondsToTime(remaining);
  },

  // 时间戳 → XX分钟前
  timestampToRelativeText(time) {
    if (!time) return "";

    let timestamp = time;

    // ⭐ 如果传入的是 "2025-11-07 14:53:54" 这种格式
    if (typeof time === "string") {
      // Safari 不支持 YYYY-MM-DD HH:mm:ss，需要替换成 YYYY/MM/DD HH:mm:ss
      timestamp = new Date(time.replace(/-/g, "/")).getTime();
    }

    // ⭐ 如果传入的是整数但单位为秒（10位），自动转换为毫秒
    if (typeof timestamp === "number" && timestamp.toString().length === 10) {
      timestamp = timestamp * 1000;
    }

    const now = Date.now();
    const diff = Math.floor((now - timestamp) / 1000); // 秒差

    if (diff < 60) {
      return "刚刚";
    } else if (diff < 3600) {
      return `${Math.floor(diff / 60)}分钟前`;
    } else if (diff < 86400) {
      return `${Math.floor(diff / 3600)}小时前`;
    } else if (diff < 86400 * 7) {
      return `${Math.floor(diff / 86400)}天前`;
    } else {
      const date = new Date(timestamp);
      const y = date.getFullYear();
      const m = (date.getMonth() + 1).toString().padStart(2, "0");
      const d = date.getDate().toString().padStart(2, "0");
      return `${y}-${m}-${d}`;
    }
  }
};
